<template lang="pug">
.close-btn(@click="$emit('clicked')")
  img(src="~assets/btn-close.png")
  
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'CloseBtn',
  components: {},
  props: {
    copy: {},
    to: {},
    from: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.close-btn
  position: absolute
  width: pxToRem(60)
  height: pxToRem(60)
  img
    width: 100%
    height: 100%
    object-fit: contain
    display: block
</style>
